/**
 * GENERATED BY KRPC GEN - LESS MODIFY BY HAND
 * coupon-service.ts  2026-01-21T16:22:03+08:00
 */
import type { R, RpcService, MethodConfig as M } from 'krpc-base'

const _ = 'Coupon/'

export class CouponService {
  constructor(readonly r: RpcService) {}
  // 膨胀优惠券，成功返回膨胀后金额(单位：分)
  expandCoupon(d: number, m?: M): R<number> {
    return this.r.async(_ + 'expandCoupon', d, m)
  }
}
